import { Backdrop } from '@mui/material';
import React from 'react';

interface SystemBackdropProps extends React.PropsWithChildren {
    isOpen?: boolean;
    handleClose?: () => void;
}

export const SystemBackdrop: React.FC<SystemBackdropProps> = (props) => {
    const { children, isOpen = true, handleClose } = props

    const handleClick = () => {
        if (handleClose) {
            handleClose()
        }
    }

    return (
        <Backdrop
            open={isOpen}
            onClick={handleClick}
            sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        >
            {children}
        </Backdrop>
    )
}
